// extracted by mini-css-extract-plugin
export default {"searchBox":"Search_searchBox__GJ5k0","inputSearch":"Search_inputSearch__otTXO"};